/**
 * Created by hp on 2017/5/19.
 */
import React from 'react'
import {connect} from 'react-redux'
import {Dialog} from 'react-weui'
import {getTimestamp} from '../../utils'


import '../../styles/classroom/ClassroomTextareaPanel.css'


class ClassroomTextareaPanel extends React.Component {
    state = {
        buttons: [
            {
                type: 'default',
                label: '取消',
                onClick: this.hide.bind(this)
            },
            {
                type: 'primary',
                label: '发送',
                onClick: this.send.bind(this)
            }
        ]
    };

    send() {
        const content = this.refs.text.value;
        if (content.length < 1) {
            return;
        }

        const {timestampDelta} = this.props;
        let timestamp = getTimestamp(timestampDelta);
        this.props.dispatch({
            type: 'ML_SEND_MESSAGE',
            payload: {
                type: 'text',
                content: content,
                account: this.props.account,
                reply: this.props.reply,
                timestamp: timestamp
            }
        });
        this.refs.text.value = '';
        this.hide()
    }

    hide() {
        this.props.dispatch({
            type: 'CLASSROOM_HIDE_TEXTAREA_PANEL'
        })
    }


    render() {
        const {showTextareaPanel} = this.props;
        return <Dialog className="textarea-panel"
                       title="长文本内容"
                       buttons={this.state.buttons}
                       show={showTextareaPanel}>
            <p className="tips">长文本便于编辑，支持换行</p>
            <textarea ref="text"></textarea>
        </Dialog>
    }
}


export default connect((state) => ({
    lecture: state.classroom.lecture,
    account: state.account,
    reply: state.classroom.reply,
    showTextareaPanel: state.classroom.showTextareaPanel,
    timestampDelta: state.classroom.timestampDelta,
}))(ClassroomTextareaPanel)




// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomTextareaPanel.js